import { render, staticRenderFns } from "./EditeName.vue?vue&type=template&id=bfae4cd8&scoped=true&"
import script from "./EditeName.vue?vue&type=script&lang=js&"
export * from "./EditeName.vue?vue&type=script&lang=js&"
import style0 from "./EditeName.vue?vue&type=style&index=0&id=bfae4cd8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfae4cd8",
  null
  
)

export default component.exports